import { Component } from '@angular/core';
import { NavController, AlertController, ToastController, LoadingController, ViewController, NavParams } from 'ionic-angular';

import { Assignment, User  } from '@providers/asset/index';

import { FormAssignmentPage } from '../form_assignment/page';
import { DetailItemPage } from '../detail_item/page';
import { AssignmentResPage } from '../assignment_result/page';

@Component({
  selector: 'page-assignment',
  templateUrl: 'page.html'
})
export class AssignmentPage {

  item = {
    id : '',
    assignor_id:''
  }

  List: any = [];
  selectedID= [0];
  data_user : any=[];

  constructor(
    public navCtrl: NavController,
    public assignmentApi: Assignment,
    public userApi : User,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.data_user = JSON.parse(localStorage.data_user);
    this.item.assignor_id = this.data_user.data.employee_id;
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position:  'top'
    });
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
      let params = {  };
      this.assignmentApi.get(params).subscribe((resp:any) => {
        if(resp.count!=0){
          this.List = resp.data;
          console.log(this.List);
        }else{
          this.presentToast("No Assignment data !");
        }
        loading.dismiss();
        return false;
      }, (err) => {
        loading.dismiss();
      });

  }

  select(asset_id){
    this.navCtrl.push(DetailItemPage, {
      id:asset_id
    });
  }
  
  add(){
    let params= {assignment:1};
    this.navCtrl.push(FormAssignmentPage,params);
  }

  edit(item){
    let params = {item:item};
    this.navCtrl.push(FormAssignmentPage, params);
  }

  getRes(id, loc_path, asset_id, location_id, project_code, project_title){
    let params:any={
      assignment_id:id
    }
    if(location_id!=null){
      params.asset_location_id=location_id, 
      params.location_path_id=loc_path,
      params.assign_type = 'location';
    }
    if(project_code!=''){
      params.project_code=project_code,
      params.project_title = project_title,
      params.assign_type  = 'project';
    }
    if(asset_id!=0){
      params.id=asset_id
    }
    this.navCtrl.push(AssignmentResPage, params);
  }

  
  removeItem(id){
    const confirm = this.alertCtrl.create({
      title: 'Hapus Penuugasan ?',
      message: 'Anda yakin ingin menghapus assignment ini dari daftar ?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Ya',
          handler: () => {
            let params:any={id:id}
            this.assignmentApi.removeItem(params).subscribe((resp:any) =>{
              this.presentToast(resp.msg);
              console.log("remove item => ",resp);
              this.getList();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  removeAkses(id){
    const confirm = this.alertCtrl.create({
      title: 'Cabut Penugasan',
      message: 'Anda yakin ingin mencabut hak akses untuk penugasan ini ?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Ya',
          handler: () => {
            let params:any={id:id}
            this.assignmentApi.removeAkses(params).subscribe((resp:any) =>{
              this.presentToast(resp.msg);
              console.log("remove akses => ",resp);
              this.getList();
            });
          }
        }
      ]
    });
    confirm.present();
  }
  

}



// WEBPACK FOOTER //
// ./src/pages/asset/assignment/page.ts